// /client/src/components/Programs.js (Updated with table and sorting)
import React, { useState, useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';
import Navigation from './Navigation';

const ProgramView = () => {
  const { user } = useAuth();
  
  return (
    <>
      {/* Main Content */}
      <section className="theme-light m-0 p-0" data-theme="light">
        <div className='is-flex is-flex-direction-column is-justify-content-center'>
          
          <Navigation />
          <div className='mt-2 pt-6 container'>
            <div className='is-flex is-flex-direction-rows is-justify-content-space-between is-align-center'>
                <h1 className='h1 my-2'>Create Program</h1>
            </div>
          </div>

          <div className='mt-2 pt-5 container'>
            {/* Insert form here */}
          </div>

        </div>
      </section>
    </>
  );
};

export default ProgramView;